import {Component, Input, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {CountriesListService} from '../../../services/countries-list.service';
import {UserService} from '../../../services/user.service';
import {AuthService} from '../../../services/auth.service';

@Component({
  selector: 'user-settings',
  templateUrl: './user-settings.component.html',
  styleUrls: ['./user-settings.component.scss']
})
export class UserSettingsComponent implements OnInit {
  profileView: boolean;
  loginActivityView: boolean;
  auditLogView: boolean;
  changePasswordView: boolean;

  @Input()
  staffView: boolean;

  constructor(private authService: AuthService,
              private userService: UserService, private title: Title, private countriesListService: CountriesListService, private router: Router) {
  }

  ngOnInit() {
    this.getInputData(history.state);
    this.title.setTitle('User Settings');
    this.countriesListService.load();
    this.changeViewToProfile();
  }

  getInputData(data: any) {
    if (data) {
      this.staffView = data.staffView;
    } else {
      this.router.navigateByUrl('/user/home');
    }
  }

  changeViewToProfile() {
    this.profileView = true;
    this.auditLogView = false;
    this.loginActivityView = false;
    this.changePasswordView = false;
  }

  changeViewToLoginActivity() {
    this.profileView = false;
    this.auditLogView = false;
    this.loginActivityView = true;
    this.changePasswordView = false;
  }

  changeViewToActivityLog() {
    this.profileView = false;
    this.auditLogView = true;
    this.loginActivityView = false;
    this.changePasswordView = false;
  }

  changeViewToChangePasswordView() {
    this.profileView = false;
    this.auditLogView = false;
    this.loginActivityView = false;
    this.changePasswordView = true;
  }

}
